import { AppApi, ScreenView, el, panel, button, fmt } from '../ui/app-api'

export function createLeaderboardScreen(api: AppApi): ScreenView {
  const root = el('div', { class: 'screen' })
  const p = panel('Leaderboard', true)
  const list = el('div', { class: 'scroll-area', style: { maxHeight: '58vh' } })
  const back = button('BACK', { variant: 'secondary', onClick: () => api.go('menu') })
  p.append(list, back)
  root.append(p)

  let showToken = 0

  return {
    el: root,
    async onShow() {
      const token = ++showToken
      list.replaceChildren(el('p', { class: 'muted center', text: 'Loading scores…' }))
      try {
        const scores = await api.economy.leaderboard(25)
        if (token !== showToken) return // a newer onShow superseded this fetch
        list.replaceChildren()
        if (!scores.length) {
          list.append(el('p', { class: 'muted center', text: 'No scores yet — be the first!' }))
          return
        }
        scores.forEach((s, i) => {
          const row = el('div', { class: 'row' })
          const left = el(
            'div',
            { class: 'row-main', style: { flexDirection: 'row', alignItems: 'center', gap: '10px' } },
            el('span', { class: 'lb-rank', text: `${i + 1}` }),
            // nickname is user-supplied → textContent only (no innerHTML)
            el('span', { class: 'row-name', text: s.nickname || 'Anonymous' }),
          )
          const right = el(
            'div',
            { class: 'row-actions' },
            el('span', { class: 'muted', text: `Lv ${s.level}` }),
            el('span', { class: 'lb-score', text: fmt(s.score) }),
          )
          row.append(left, right)
          list.append(row)
        })
      } catch {
        if (token !== showToken) return
        list.replaceChildren(el('p', { class: 'muted center', text: 'Leaderboard unavailable — server offline.' }))
      }
    },
  }
}
